<mat-dialog-content>
  @if (title) {
    <h3 mat-dialog-title>{{title}}</h3>
  }
  @if (form ) {
    <form [formGroup]="form">
      @if (visualizedInTabGroup) {
        <mat-tab-group>
          @for (tab of htmlData; track tab) {
            <mat-tab [label]="tab.tabGroupName|translate">
              @for (form of tab.forms; track form) {
                <app-get-form-field-from-configuration-file [type]="form.type"
                  [titleTraduction]="form.traduction" [possibleValues]="form.possibleValues"
                  [formControlName]="form.formControlName">
                </app-get-form-field-from-configuration-file>
                @if (form.formGroupChild) {
                  <mat-card>
                    <ng-container [formGroupName]="form.formGroupChild.formGroupName">
                      @for (subForm of form.formGroupChild.fields; track subForm) {
                        <app-get-form-field-from-configuration-file [type]="subForm.type"
                          [titleTraduction]="subForm.traduction"
                          [possibleValues]="subForm.possibleValues"
                          [formControlName]="subForm.formControlName">
                        </app-get-form-field-from-configuration-file>
                      }
                    </ng-container>
                  </mat-card>
                }
              }
            </mat-tab>
          }
        </mat-tab-group>
      } @else {
        @for (tab of htmlData; track tab) {
          @for (form of tab.forms; track form) {
            <app-get-form-field-from-configuration-file [type]="form.type" [titleTraduction]="form.traduction"
              [possibleValues]="form.possibleValues" [formControlName]="form.formControlName">
            </app-get-form-field-from-configuration-file>
            @if (form.formGroupChild) {
              <mat-card>
                <ng-container [formGroupName]="form.formGroupChild.formGroupName">
                  @for (subForm of form.formGroupChild.fields; track subForm) {
                    <app-get-form-field-from-configuration-file [type]="subForm.type"
                      [titleTraduction]="subForm.traduction" [possibleValues]="subForm.possibleValues"
                      [formControlName]="subForm.formControlName">
                    </app-get-form-field-from-configuration-file>
                  }
                </ng-container>
              </mat-card>
            }
          }
        }
      }
    </form>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button class="fab" color="accent" mat-flat-button matTooltip="{{'button.save' | translate}}" mat-dialog-close>
    <mat-icon>clear</mat-icon>
  </button>
  @if (!disableForm) {
    <button class="fab" color="primary" mat-flat-button [disabled]="!this.isBatchEdit && this.form?.invalid"
      matTooltip="{{'button.save' | translate}}" (click)="clickSaveButton()">
      <mat-icon>save</mat-icon>
    </button>
  }
</mat-dialog-actions>